import styled from '@emotion/styled';

export const SadaServiceSplashImage = styled.div``;
